import { ColumnDef } from "@tanstack/react-table";
import { Text } from "@volca/ui/components/ui/text";
import { formatMoneyCents } from "@/core/utils/money";
import { IInternalTransaction } from "@/internal-transactions/InternalTransactions";

export const AmountCol = (): ColumnDef<IInternalTransaction> => ({
  header: "Amount",
  accessorKey: "amount",
  cell: ({ row }) => {
    const { amount, type } = row.original;

    const isDeposit = type === "deposit";

    return (
      <Text className="tabular-nums" tone={isDeposit ? "success" : undefined}>
        {isDeposit && "+"}
        {formatMoneyCents(amount)}
      </Text>
    );
  },
});
